<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditRedeemCodeGiftDialog(true, null)"
      >新增礼包</el-button
    >
    <el-tooltip style="margin-left: 10px" effect="dark" placement="top">
      <div slot="content">
        1、要生成兑换码，得先创建至少1个礼包，因为生成兑换码时，需要指定兑换码要绑定哪个礼包
        <br />
        2、使用兑换码时，会发放兑换码所绑定的礼包
        <br />
        3、礼包是可重复使用的，可以基于同一个礼包多批次生成兑换码，不必每次生成兑换码前都新建一个礼包
      </div>
      <span style="font-size: 1.5rem"><i class="el-icon-question"></i></span>
    </el-tooltip>

    <el-button
      style="margin-bottom: 10px; margin-left: 20px"
      type="primary"
      icon="el-icon-document-copy"
      :disabled="this.selectionList.length == 0"
      @click="copyToClipboard()"
      >复制到剪贴板</el-button
    >
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-document-add"
      @click="addFromClipboard()"
      >从剪贴板添加</el-button
    >
    <el-table
      @select="select"
      @select-all="select"
      :data="list"
      border
      size="small"
      style="width: 1554px"
    >
      <el-table-column type="selection" width="48"> </el-table-column> 
      <el-table-column
        prop="createdAt"
        label="创建时间"
        sortable
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          {{ $util.ms2datetime(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        sortable
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          {{ $util.ms2datetime(scope.row.updatedAt) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="adminUsername"
        label="创建人"
        sortable
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        sortable
        align="center"
        width="180"
        show-overflow-tooltip
      >
      </el-table-column>

      <el-table-column label="道具" align="center" width="350">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.props" :key="index">
            {{ attachments[item.id] }} x {{ item.amount }}
            <el-popover
              v-if="itemDescOfPayAttachment[item.id]"
              placement="right"
              trigger="click"
            >
              <div
                v-for="(itemsOfPay, indexOfPay) in itemDescOfPayAttachment[
                  item.id
                ]"
                :key="indexOfPay"
              >
                {{ itemsOfPay.name }} x {{ itemsOfPay.number }}
              </div>
              <a
                slot="reference"
                style="text-decoration: none; font-size: small"
                href="javascript:;"
                >[详情]</a
              >
            </el-popover>
          </div>
        </template>
      </el-table-column>    
      <el-table-column
        label="仅可被同一玩家领取一次"
        align="center"
        width="110"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.availableRedeemTimes" style="color: red"
            >是</span
          >
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column prop="eigenvalue" align="center" width="150" show-overflow-tooltip>
        <template slot="header">
          <span>特征值</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                特殊用途，比如某个业务可以规定在该业务当中最多能够使用几次具备特定特征值的礼包
              </div>
              <span><i class="el-icon-question" style="font-size: 1.2em"></i></span>
            </el-tooltip>
          </div>
        </template> 
      </el-table-column>        
      <el-table-column label="兑换码批次数" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.row.cycleTimes }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="235">
        <template slot-scope="scope">
          <span
            class="link-button"
            style="color: red"
            @click="remove(scope.row)"
            >删除</span
          >
          <span
            class="link-button"
            @click="openEditRedeemCodeGiftDialog(false, scope.row)"
            >编辑</span
          >
          <span
            class="link-button"
            @click="openRedeemCodeGiftDetailsDialog(scope.row)"
            >兑换码批次</span
          >
          <span class="link-button" @click="openAddRedeemCodeDialog(scope.row)"
            >生成兑换码</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  data() {
    return {
      list: [],
      attachments: {},
      selectionList: [],
      itemDescOfPayAttachment: {},
    };
  },

  components: {},
  async created() {
    await this.loadPayShopDesc();
    this.attachments = await this.$bizutil.loadAttachments(true);
    this.loadList();
  },
  methods: {
    select(selection, row) {
      this.selectionList = selection;
    },
    /**
     * 拉取集合
     */
    async loadList() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryRedeemCodeGifts`,
          {},
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = listInResponse;
    },

    /**
     * 拉取集合
     */
    async loadPayShopDesc() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryPayProductItems`,
          {},
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      for (let item of resData.data.list) {
        this.itemDescOfPayAttachment[item.payConfId] = item.items;
      }
    },

    /**
     * 删除礼包
     */
    async remove(entry) {
      // 弹确认框
      await this.$prompt(
        `
                <span style="color:red">该操作会导致绑定在礼包上的所有兑换码失效！！！</span>
                <br/>确认操作请输入礼包名称
                <span style="padding-left:5px; padding-right:5px; color:red;background-color:rgb(236, 226, 226);">
                    ${entry.name}</span>&nbsp;：
                `,
        "删除礼包",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async ({ value }) => {
          if (String(value).trim() != entry.name) {
            this.$message.error("输入内容不合法");
            return;
          }
          await this.exceRemoveGift(entry);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },

    async exceRemoveGift(entry) {
      try {
        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/delRedeemCodeGift`,
            {
              giftId: entry.id,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == entry.id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    /**
     * 打开编辑礼包对话框
     */
    async openEditRedeemCodeGiftDialog(isCreate, oldData) {
      this.$dialogutil.open("EditRedeemCodeGiftDialog", {
        closedCallback: () => {
          this.loadList();
        },
        data: { isCreate: isCreate, entry: oldData },
      });
    },
    /**
     * 打开生成兑换码对话框
     */
    async openAddRedeemCodeDialog(entry) {
      this.$dialogutil.open("AddRedeemCodeDialog", {
        closedCallback: () => {
          this.loadList();
        },
        data: { entry },
      });
    },

    /**
     * 打开兑换码礼包详情弹窗
     */
    async openRedeemCodeGiftDetailsDialog(entry) {
      this.$dialogutil.open("RedeemCodeGiftDetailsDialog", {
        closedCallback: null,
        data: { entry },
      });
    },

    /**
     * 复制到剪贴板
     */
    async copyToClipboard() {
      if (this.selectionList.length == 0) {
        this.$message({
          message: "未选中任何可复制内容",
          type: "warning",
        });
      }
      try {
        await navigator.clipboard.writeText(
          JSON.stringify({ copyReedomGifts: this.selectionList })
        );
        this.$message({
          message: "复制成功",
          type: "success",
        });
      } catch (err) {
        this.$message.error("复制失败： " + JSON.stringify(err));
      }
    },

    async addFromClipboard() {
      let result = await navigator.permissions.query({
        name: "clipboard-read",
      });

      if (result.state === "granted" || result.state === "prompt") {
        // 可以使用权限
        // 进行clipboard的操作
        let text = await navigator.clipboard.readText();

        let obj = JSON.parse(text).copyReedomGifts;
        if (obj) {
          for (let i = 0; i < obj.length; i++) {
            let item = obj[i];
            await this.add(item);
          }

          this.selectionList = [];
          this.loadList();
        }
      } else if (result.state === "denied") {
        alert("已禁止访问粘贴板，请手动开启权限");
      }
    },

    /**
     * 新增
     */
    async add(entry) {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/addRedeemCodeGift`,
          entry,
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      this.$message({
        message: "添加成功",
        type: "success",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 0px 0;
}

.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}
</style>